import { render, staticRenderFns } from "./configurewebsitebuilder.vue?vue&type=template&id=3d4ab3b1&"
import script from "./configurewebsitebuilder.vue?vue&type=script&lang=js&"
export * from "./configurewebsitebuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4ab3b1')) {
      api.createRecord('3d4ab3b1', component.options)
    } else {
      api.reload('3d4ab3b1', component.options)
    }
    module.hot.accept("./configurewebsitebuilder.vue?vue&type=template&id=3d4ab3b1&", function () {
      api.rerender('3d4ab3b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/websitebuilder/configurewebsitebuilder.vue"
export default component.exports